module.exports = __webpack_public_path__ + "img/data-bg.9928f4f3.png";